'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_SimpleSample$package$$anon$8(evaluator$8) {
  this.Ma = null;
  this.Ma = evaluator$8;
}
export { $c_Lsamples_SimpleSample$package$$anon$8 as $c_Lsamples_SimpleSample$package$$anon$8 };
$p = $c_Lsamples_SimpleSample$package$$anon$8.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_SimpleSample$package$$anon$8;
/** @constructor */
function $h_Lsamples_SimpleSample$package$$anon$8() {
}
export { $h_Lsamples_SimpleSample$package$$anon$8 as $h_Lsamples_SimpleSample$package$$anon$8 };
$h_Lsamples_SimpleSample$package$$anon$8.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Ma.h();
  return (((typeof v) === "boolean") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_SimpleSample$package$$anon$8 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_SimpleSample$package$$anon$8, "samples.SimpleSample$package$$anon$8", ({
  qZ: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_SimpleSample$package$$anon$8 as $d_Lsamples_SimpleSample$package$$anon$8 };
